(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_collection-card-image-shuffle"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__categoryShuffleInit) return;
    window.__categoryShuffleInit = true;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    document.querySelectorAll('.category-shuffle').forEach(function (tile) {
      var images = tile.querySelectorAll('.category-shuffle__img');
      if (images.length < 2) return;

      var intervalMs = parseInt(tile.dataset.rotationMs, 10) || 4000;
      var current = 0;
      // Stagger each tile's start slightly so a whole row doesn't flip in unison.
      var startDelay = Math.random() * intervalMs;

      setTimeout(function () {
        setInterval(function () {
          var next = (current + 1) % images.length;
          images[current].classList.remove('category-shuffle__img--active');
          images[next].classList.add('category-shuffle__img--active');
          current = next;
        }, intervalMs);
      }, startDelay);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
